export default "/wp-content/themes/onnit/script/cart/dist/onnitTotalHumanTrialUpsellBg-2f7209b1.jpg";